<!-- Toolbar above the Explorer Content -->
<div class="login-container">
    <mat-card class="loading-content">
        <!-- Loading Screen -->
        <mat-card-header header class="loading-header"> Loading</mat-card-header>
        <mat-card-content>
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </mat-card-content>
    </mat-card>
</div>